import { publishMessage } from "../notification/notificationActions";
import * as sellerLocationActionTypes from "./sellerLocationTypes";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import Axios from "axios";
import { baseUrl, getCurrentUser } from "../../util/host";

export const setSellerLocation = (sellerLocation) => {
  return {
    type: sellerLocationActionTypes.CREATE_SELLER_LOCATION,
    value: sellerLocation,
  };
};

export const setSellerLocations = (sellerLocations) => {
  return {
    type: sellerLocationActionTypes.SET_SELLER_LOCATIONS,
    value: sellerLocations,
  };
};

export const setSupplierLists = (supplierLists) => {
  return {
    type: sellerLocationActionTypes.SET_SUPLIER_LIST,
    value: supplierLists,
  };
};

export const setSupplierLocationLists = (supplierLocationLists) => {
  return {
    type: sellerLocationActionTypes.SET_SUPLIER_LOCATION_LIST,
    value: supplierLocationLists,
  };
};


export const setLocationCountries = (countries) => {
  return {
    type: sellerLocationActionTypes.GET_LOCATION_COUNTRIES,
    value: countries,
  };
};


export const updateSellerLocationSuccess = (sellerLocation) => {
  return {
    type: sellerLocationActionTypes.UPDATE_SELLER_LOCATION,
    value: sellerLocation,
  };
};

export const createSellerLocation = (sellerLocationData, onSuccess) => {
  const token = getCurrentUser()?.token || "";

  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/seller_location`,
      sellerLocationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setSellerLocation(res.data.data));
        dispatch(
          publishMessage({
            message: `Warehouse ID ${res.data.data.warehouse_id} created successfully and isSyncToInventory is ${res.data.data.is_sync_to_inventry}`,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const updateSellerLocation = (id, sellerLocationData, onSuccess) => {
  const token = getCurrentUser()?.token || "";
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.put(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/seller_location/${id}`,
      sellerLocationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "non-dynamic-url": '/api/address/location/seller_location/:id'
        },
      }
    )
      .then((res) => {
        dispatch(updateSellerLocationSuccess(res.data.data));
        dispatch(
          publishMessage({
            message: `Warehouse ID ${sellerLocationData.warehouseId} Seller location updated successfully`,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const getSellerLocations = () => {
  const token = getCurrentUser()?.token || "";

  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/seller_location`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setSellerLocations(res.data.data));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          publishMessage({
            message: "Failed to fetch seller locations",
            severity: "error",
          })
        );
        dispatch(hideSpinner());
      });
  };
};

export const getSupplierList = (selectedCountry) => {
  const selectedCountrys = selectedCountry === "IN"
    ? "IND"
    : selectedCountry === "CN"
    ? "CHN"
    : (selectedCountry === "KSA" || selectedCountry === "SA")
    ? "SAU"
    : selectedCountry;

  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(
      `${baseUrl("REACT_APP_TERRA_API_DEV_URL")}/sp/supplier/list/${selectedCountrys}`,
      {
        headers: {
          "authorization": "",
          "authorization-token": `bHVuYWRldmFwcGxpY2F0aW9u`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setSupplierLists(res.data.result));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          publishMessage({
            message: "Failed to Supplier List",
            severity: "error",
          })
        );
        dispatch(hideSpinner());
      });
  };
};

export const getSupplierLocationList = (sellerId) => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(
      `${baseUrl("REACT_APP_TERRA_API_DEV_URL")}/sp/supplier/seller-locations/${sellerId}`,
      {
        headers: {
          "authorization": "",
          "authorization-token": `bHVuYWRldmFwcGxpY2F0aW9u`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        console.log("[getSupplierLocationList] Raw API Response →", JSON.stringify(res.data.results, null, 2));
        dispatch(setSupplierLocationLists(res.data.results));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          publishMessage({
            message: "Failed to Supplier List",
            severity: "error",
          })
        );
        dispatch(hideSpinner());
      });
  };
};

export const updateSellerConfig = (sellerId, warehouseId, configuration) => {
  const omsAuthToken = process.env.REACT_APP_OMS_AUTH_TOKEN || "";
  const omsBaseUrl = process.env.REACT_APP_OMS_JAVA_API_URL || "";

  return (dispatch) => {
    const url = `${omsBaseUrl}/rest/order/oms/seller-config/configuration`;
    const requestBody = { sellerId, sellerWarehouseId: warehouseId, configuration };
    console.log("[updateSellerConfig] URL →", url);
    console.log("[updateSellerConfig] Request Body →", JSON.stringify(requestBody, null, 2));
    Axios.put(url, requestBody, {
        headers: {
          "authorization-token": omsAuthToken,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        console.log("[updateSellerConfig] Response Status →", res.status);
        console.log("[updateSellerConfig] Response Body →", JSON.stringify(res.data, null, 2));
        dispatch(
          publishMessage({
            message: `Seller config updated successfully for seller ${sellerId}`,
            severity: "success",
          })
        );
      })
      .catch((err) => {
        console.log("[updateSellerConfig] Error Status →", err?.response?.status);
        console.log("[updateSellerConfig] Error Response →", JSON.stringify(err?.response?.data, null, 2));
        console.log("[updateSellerConfig] Full Error →", err);
        dispatch(
          publishMessage({
            message: "Seller location saved, but failed to update OMS seller config",
            severity: "warning",
          })
        );
      });
  };
};

export const getLocationCountries = () => {
  const token = getCurrentUser()?.token || "";

  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(
      `${baseUrl("REACT_APP_API_URL")}/api/address/countries`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setLocationCountries(res.data.data));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          publishMessage({
            message: "Failed to fetch countries",
            severity: "error",
          })
        );
        dispatch(hideSpinner());
      });
  };
};



